import { STATUS_TYPE } from '../../../enum';
import { EngageActivity } from '../../engagePipeline/api/interface';


export interface AffiliateLandingPageVideoResponse {
  status: string;
  message: string;
  data: AffiliateLandingPageVideoItem[];
}

export interface AffiliateLandingPageVideoItem {
  id: number;
  title: string;
  position: number;
  type: string;
  link: string;
  created_at: string;
  updated_at: string;
  user_id: number;
  filename: string;
  thumb_name: string;
  thumb_link: string;
}

export interface AffiliateLandingPageVideoResult {
  title: string;
  code: string;
  data: AffiliateLandingPageVideoItem[];
}

interface InitialState {
  overview?: AffiliateLandingPageVideoItem;
  fixingTheProblem?: AffiliateLandingPageVideoItem;
  data: AffiliateLandingPageVideoItem[];
  searchResult: AffiliateLandingPageVideoResult[];
  searchText: string,
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}


export const initialState: InitialState = {
  overview: undefined,
  fixingTheProblem: undefined,
  data: [],
  searchResult: [],
  searchText: '',
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
